import { useCallback, useSyncExternalStore } from 'react';
import { getPortalRoot, HINT_ROOT_ID, MODAL_ROOT_ID, subscribePortalRoot, TOAST_ROOT_ID } from 'utils/fnPortalRoot';

export const usePortalRoot = (id: string): HTMLElement => {
    const getSnapshot = useCallback(() => getPortalRoot(id), [id]);

    return useSyncExternalStore(subscribePortalRoot, getSnapshot, getSnapshot);
};

export const useModalRoot = (): HTMLElement => usePortalRoot(MODAL_ROOT_ID);

export const useHintRoot = (): HTMLElement => usePortalRoot(HINT_ROOT_ID);

export const useToastRoot = (): HTMLElement => usePortalRoot(TOAST_ROOT_ID);
